import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useBnsMeiJieUpdateQuery, useBnsMeiJieUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import MyEditor from '../../cpn/MyEditor';
function MediaEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bmj_content:''
    }); 
    const {data,isSuccess} = useBnsMeiJieUpdateQuery({bmj_id:props.bmj_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bmj_name:data.Result.bmj_name,
                    bmj_dept_id:data.Result.bmj_dept_id,
                    bmj_content:data.Result.bmj_content,                   
                })
                setInfo(prevState=>({...prevState,
                    bmj_name:data.Result.bmj_name,
                    bmj_dept_id:data.Result.bmj_dept_id,
                    bmj_dept_name:data.Result.bmj_dept_name,
                    bmj_content:data.Result.bmj_content,                         
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsMeiJieUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改意向客户'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({                      
                        "bmj_uid" : localStorage.getItem('eu_id'),
                        "bmj_uname" : localStorage.getItem('eu_name'),
                        "bmj_content" : info.bmj_content,
                        "bmj_dept_id" : info.bmj_dept_id,
                        "bmj_dept_name" : info.bmj_dept_name,
                        "bmj_e_id" : localStorage.getItem('e_id'),                    
                        "bmj_name" : info.bmj_name,                              
                        "bmj_id" : props.bmj_id,                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                   <GetUserDept 
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bmj_dept_id:e,bmj_dept_name:f}))
                        }}
                        name='bmj_dept_id'
                    />
                    <Form.Item name="bmj_name" label='名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bmj_name:e.target.value}))}}
                        />
                    </Form.Item>     
                    <Form.Item
                        label='备注'
                        wrapperCol={{span:20}}
                        name='bmj_content'
                    >
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bmj_content:e}))}}/>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default MediaEdit